<template>
  <v-row class="bottom-content">
    <v-col cols="3" class="my-3 mx-2" v-if="checkPermission('student-detail_read')">
      <div class="bottom-left" style="height: 100%;">
        <div class="my-2"><switch-subject></switch-subject></div>
        <div class="mt-2 mb-2 pa-3 bottom-left-class-list" v-if="listSubjects && listSubjects.length">
          <div class="font-weight-bold text-uppercase">
            <span class="text-uppercase">{{ activeClass ? `CÁC KHÓA TỰ HỌC (${showTotalSubject()} KHÓA)` : `CÁC LỚP ĐANG HỌC (${showTotalSubject()} LỚP)` }}</span>
          </div>
          <div class="bottom-left-title w-100 overflow-auto mt-2" id="style-2">
            <div class="bottom-left-title-item text-no-wrap"
                :class="filterForm.subjectId == subject.subjectId ? 'active' : ''"
                v-for="subject of listSubjects" :key="subject.subjectId"
                @click="changeSubject(subject)">
              <span>{{ subject.subjectName }} ({{subject.courses.length}})</span>
            </div>
          </div>
          <DetailClass v-if="!activeClass" :listClassDuo='listSubjectDetailFilter'></DetailClass>
          <div id="style-2" v-if="activeClass" style="max-height: 600px; overflow: auto">
            <div
              class="class-item mb-2"
              v-for="(item,key) in listSubjectDetailFilter"
              :key="key"
            >
              <div class="class-studying">
                <div class="class-studying-item mt-4">
                  <div class="mb-2 d-flex align-center">
                    <img src="../../assets/book-open.svg" width="16" height="16" alt="" class="mr-2">
                    <b style="font-weight: 700">
                      <span class="text-uppercase mr-4">{{ item.className }}</span>
                      <span style="color: #F2994A" class="text-uppercase">{{ item.classLevel }}</span>
                    </b>
                  </div>
                  <div class="mb-2 d-flex align-center">
                    <img src="../../assets/school.svg" width="16" height="16" alt="" class="mr-2">
                    <span>
                    <span v-if="item.classStatus" :style="'font-weight:600; color:' + (STATUS_COURSES.find((e) => e.status === item.classStatus) ? STATUS_COURSES.find((e) => e.status === item.classStatus).color : '#000000')">
                      {{ item.classStatus }}
                    </span>
                  </span>
                  </div>
                  <div class="mb-2 d-flex align-center">
                    <img src="../../assets/video.svg" width="16" height="16" class="mr-2" alt="">
                    <span >Video đã xem: {{ item.totalVideoViewed }}/{{item.totalVideo}}</span>
                  </div>
                  <div class="mb-2 d-flex align-center">
                    <img src="../../assets/homework.svg" width="16" height="16" class="mr-2" alt="">
                    <span >Bài tập hoàn thành: {{ item.totalHomeworkCompleted }}/{{item.totalHomework}}</span>
                  </div>
                  <div class="mb-2 d-flex align-center">
                    <img src="../../assets/calendar-xmark.svg" width="16" height="16" class="mr-2" alt="">
                    <span >
                    Ngày hết hạn: <span class="red--text">{{ item.classEndDate ? item.classEndDate : '' }}</span>
                  </span>
                  </div>
                  <div class="d-flex align-center">
                    <img src="../../assets/last-join.svg" width="16" height="16" class="mr-2" alt="">
                    <span >
                    Lần cuối vào học: <span>{{ item.classLastJoinDate ? item.classLastJoinDate : '' }}</span>
                  </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 mb-2 pa-3 d-flex align-center justify-center" v-else style="height: 100%">
          <div class="d-flex flex-column align-center">
            <img src="../../assets/no-classes-icon.svg" height="64" width="64" alt="">
            <div style="color: #ABAAAA" class="mt-3">
              Học sinh chưa có {{activeClass ? 'khoá' : 'lớp'}} nào.
            </div>
          </div>
        </div>
      </div>
    </v-col>
    <!---->
    <v-col :cols="checkPermission('student-detail_read') ? 9 : 12" class="my-3 mx-2" style="background: white">
      <div class="bottom-right">
        <!---->
        <div class="bottom-right-bottom">
          <div>
            <v-tabs v-model="tabCare">
              <v-tabs-slider color="#1976d2"></v-tabs-slider>
              <v-tab
                v-for="item in itemsCareTabs"
                :key="item.key"
                class="no-uppercase"
                @change="changeTabDuoCare(item)"
              >
                {{ item.title }}
                <div
                  v-if="(studentDuoDetail.type_customer_care === 1 && item.key === 'routine-care')"
                  class="list-status-current px-1 ml-2"
                  :style="generateCss(mapCallStatus && mapCallStatus[studentDuoDetail.call_status_id] ? mapCallStatus[studentDuoDetail.call_status_id].color : '')"
                >{{ mapCallStatus && mapCallStatus[studentDuoDetail.call_status_id] ? mapCallStatus[studentDuoDetail.call_status_id].callType : '' }}
                </div>
                <div
                  v-if="(studentDuoRelated.type_customer_care === 1 && item.key === 'routine-care')"
                  class="list-status-current px-1 ml-2"
                  :style="generateCss(mapCallStatus && mapCallStatus[studentDuoRelated.call_status_id] ? mapCallStatus[studentDuoRelated.call_status_id].color : '')"
                >{{ mapCallStatus && mapCallStatus[studentDuoRelated.call_status_id] ? mapCallStatus[studentDuoRelated.call_status_id].callType : '' }}
                </div>
              </v-tab>
            </v-tabs>
          </div>
          <div class="care-tab-items-view">
            <v-tabs-items v-model="tabCare">
              <v-tab-item
                v-for="item in itemsCareTabs"
                :key="item.key"
              >
                <v-card flat>
                  <div v-if="(item.key === 'routine-care' && (studentDuoDetail.type_customer_care === 1 || studentDuoRelated.type_customer_care === 1))
                            || (item.key === 'extend' && (studentDuoDetail.type_customer_care === 2 || studentDuoRelated.type_customer_care === 2))">
                    <div
                      class="bottom-right-top mb-8"
                      v-if="(item.key === 'routine-care' && checkPermission('student-periodic-care-tab_update'))
                            || (item.key === 'extend' && checkPermission('student-extend-tab_update'))">
                      <div class="mb-4 d-flex align-center">
<!--                        <div class="text-uppercase font-weight-bold mt-1">{{ typeCustomerCareName }}</div>-->
                      </div>
                      <validation-observer ref="validator" v-slot="{ handleSubmit }">
                        <div class="duo-care-form">
                          <v-row class="w-100">
                            <v-col cols="12" md="2">
                              <validation-provider
                                v-slot="{ errors }"
                                class="mb-2"
                                :rules="{ required: true }"
                                name="Trạng thái"
                              >
                                <v-autocomplete
                                  label="Trạng thái *"
                                  :items="listDuoCareStatusOfCall"
                                  item-text="name"
                                  item-value="id"
                                  clearable
                                  hide-details="auto"
                                  placeholder="Chọn trạng thái"
                                  persistent-placeholder
                                  v-model="duoNote.callStatusId"
                                  :error-messages="errors"
                                ></v-autocomplete>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12" md="10">
                              <validation-provider
                                v-slot="{ errors }"
                                class="mb-2"
                                :rules="{ required: true, max: 255 }"
                                name="Mô tả"
                              >
                                <v-text-field
                                  ref="duo-note"
                                  label="Mô tả *"
                                  placeholder="Nhập mô tả"
                                  persistent-placeholder
                                  v-model="duoNote.note"
                                  hide-details="auto"
                                  @keyup.enter="handleSubmit(createDuoCareNote)"
                                  :error-messages="errors"
                                ></v-text-field>
                              </validation-provider>
                            </v-col>
                          </v-row>
                          <div style="justify-content: end">
                            <v-btn class="update-button" depressed :loading="disableSubmit" :disabled="disableSubmit" @click="handleSubmit(createDuoCareNote)">
                              Cập nhật
                            </v-btn>
                          </div>
                        </div>
                      </validation-observer>
                    </div>
                    <div style="border-bottom: 1px solid #dadada;" class="pb-3 mb-3 ml-2 font-weight-bold">
                      LỊCH SỬ {{ tabCare === 0 ? 'CHĂM SÓC' : 'GIA HẠN' }}
                    </div>
                    <div id="style-2" style="max-height: 500px; overflow: auto; padding-top: 20px;padding-right: 20px">
                      <v-timeline
                        dense
                        class="custom-timeline"
                        v-if="listHistoryCare.length > 0"
                      >
                        <v-timeline-item right v-for="(item, index) in listHistoryCare" :key="index" class="mb-9">
                          <template slot="icon">
                            <div class="list-status-history-timeline px-1"
                                 :style="generateCss(mapCallStatus && mapCallStatus[item.call_status_id] ? mapCallStatus[item.call_status_id].color : '')">
                              {{
                                mapCallStatus && mapCallStatus[item.call_status_id] ?
                                  `${mapCallStatus[item.call_status_id].callType} - ${mapCallStatus[item.call_status_id].callStatus}` : ''
                              }}
                            </div>
                          </template>
                          <div class="ml-3">
                            <div class="d-flex mb-1 pl-4">
                              <div class="history-care-created-at">{{ formatDateCus(item.created_at, 'DD.MM.YYYY HH:mm') }}</div>
                              <div class="font-weight-bold ml-8">
                                <span style="color: #006F9E">{{item.created_name ? item.created_name : 'Log hệ thống'}}</span>
                              </div>
                            </div>
                            <v-row class="align-center history-care-item-bottom">
                              <div style="padding-top: 22px; padding-bottom: 22px">
                                <div class="history-care-note mb-0" style="max-width: 900px;">{{ item.note }}</div>
                              </div>
                            </v-row>
                          </div>
                        </v-timeline-item>
                      </v-timeline>
                      <div v-else style="height: 460px">
                        <div class="d-flex flex-column align-center justify-center" style="height: 100%">
                          <img src="../../assets/no-data-care-icon.svg" height="64" width="64" alt="">
                          <div style="color: #828282">
                            Chưa có thông tin {{ tabCare === 0 ? 'chăm sóc học viên' : 'thông tin gia hạn' }}
                          </div>
                        </div>
                      </div>
                    </div>
<!--                    <div v-if="listHistoryCare.length" class="px-3 py-1 history-care-content">-->
<!--                      <div v-for="(item, index) in listHistoryCare" :key="index" class="item-history-care mb-3">-->
<!--                        <div class="history-care-created-at mb-3">{{ formatDateCus(item.created_at, 'DD.MM.YYYY HH:mm') }}</div>-->
<!--                        <v-row class="align-center history-care-item-bottom">-->
<!--                          <div style="width: 100px; margin-left: 0px;">-->
<!--                            <div class="font-weight-bold">-->
<!--                              <span>{{item.created_name ? item.created_name : 'Log hệ thống'}}</span>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                          <div style="width: 150px;">-->
<!--                            <td class="list-status-history-timeline px-1"-->
<!--                                :style="generateCss(mapCallStatus && mapCallStatus[item.call_status_id] ? mapCallStatus[item.call_status_id].color : '')">-->
<!--                              {{-->
<!--                                mapCallStatus && mapCallStatus[item.call_status_id] ?-->
<!--                                  `${mapCallStatus[item.call_status_id].callType} - ${mapCallStatus[item.call_status_id].callStatus}` : ''-->
<!--                              }}-->
<!--                            </td>-->
<!--                          </div>-->
<!--                          <div style="max-width: calc(100% - 370px)">-->
<!--                            <p class="history-care-note mb-0">{{ item.note }}</p>-->
<!--                          </div>-->
<!--                        </v-row>-->
<!--                      </div>-->
<!--                    </div>-->
                  </div>
                  <div v-if="item.key === 'care-logs'" class="review my-3">
                    <div class="table-container">
                      <v-simple-table
                        fixed-header height="300px"
                        v-if="listDuoCareLog && listDuoCareLog.length"
                        class="custom-table table-container" id="style-2">
                        <template v-slot:default>
                          <thead>
                          <tr>
                            <th class="text-no-wrap" style="min-width: 200px; max-width: 200px">Người thực hiện</th>
                            <th style="min-width: 200px; max-width: 200px">Thời gian</th>
                            <th style="min-width: 600px; max-width: 600px;">Mô tả</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(logItem, index) in listDuoCareLog" :key="index">
                            <td>{{ logItem.creatorFullName }}</td>
                            <td class="text-no-wrap">{{ formatDateCus(logItem.createdAt, 'YYYY/MM/DD HH:mm') }}</td>
                            <td>{{ logItem.description }}</td>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <div v-if="_.isEmpty(listDuoCareLog) && !loading" style="color: red">Không có hoạt động nào!</div>
                    </div>
                  </div>
                  <div v-if="item.key === 'order-list'" style="height: 390px; overflow-y: auto;">
                    <div class="pt-3">
                      <OrderHistory
                        projectName="CRM"
                        :totalListOrder="totalListOrder"
                        @redirectOrder="handleRedirectOrder($event)"
                        @toOrderDetail="toOrderDetail($event)"
                        @openDetailOrder="openDetailOrder($event)"
                        @openDetailOrderGroup="openDetailOrderGroup($event)"
                      />
                    </div>
                  </div>
                  <div v-if="item.key === 'study-result'">
                    <!-- <StudyResultTab
                      @change-loading-state="handleChangeLoadingState"
                      v-show="!loading"
                      :subjectId="filterForm.subjectId"
                      :userId="studentDuoDetail.lms_core_user_id"
                    ></StudyResultTab> -->
                    <StudyResultTabNew :userId="studentDuoDetail.lms_core_user_id" :subjectId="filterForm.subjectId"></StudyResultTabNew>
                  </div>
                  <div v-if="item.key === 'ticket'">
                    <TicketTab type="duo" :contactData="contactData"></TicketTab>
                  </div>
                  <div v-if="item.key === 'exchange'">
                    <ExchangeTab ref="exchangeTab" :contactData="contactData"></ExchangeTab>
                  </div>
                  <div>
                    <v-progress-circular
                      v-if="loading"
                      indeterminate
                      color="primary"
                      style="width: 100%"
                    ></v-progress-circular>
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { PRODUCT_COMBO_ORDER_TYPE, PRODUCT_TRIAL_TYPE } from '@/modules/student_care/constant/constant';
import { ORDER_RECEIPT_STATUS_MAP } from '@/modules/student_detail_bt/constant';
import checkPermission from '@/modules/student_care/mixins/checkPermission';
import { mapActions, mapGetters, mapState } from 'vuex';
import * as moment from 'moment';
import {
  namesOrderContactStatusTc,
  ORDER_DEPOSIT_TYPE,
  ORDER_FINISH_TYPE,
} from '@/modules/duo_care/constant';
import OrderRepository from '@/services/OrderRepository';
import TicketTab from '@/modules/student_detail_bt/components/TicketTab.vue';
import ExchangeTab from '@/modules/duo_care/components/ExchangeTab.vue';
import OrderHistory from '../../../../../vh-sub-modules/ShareModules/src/components/OrderHistory.vue';
import TokenService from '../../../../helpers/token';
import StudentCareMixins from '../../../student_care/mixins/StudentCareMixins';
import StudentCareServices from '../../../../services/StudentCareServices';
import StudyResultTabNew from './StudyResultTabNew.vue';
import SwitchSubject from './SwitchSubject.vue';
import DetailClass from './ClassDuo/DetailClass.vue';
import {
  contactCreator, STATUS_COURSES, SUBJECTS_SORT_CLASS, LOAI_GIAOVIEN, PACKAGE_FEE, ORDER_VERSION,
} from '../../../../helpers/constant';

export default {
  name: 'StudentCareBottomContent',
  components: {
    StudyResultTabNew, TicketTab, ExchangeTab, SwitchSubject, DetailClass, OrderHistory,
  },
  props: ['contactData',
    'filterForm', 'studentDuoDetail', 'listSubjects', 'studentDuoRelated'],
  mixins: [StudentCareMixins, checkPermission],
  data() {
    return {
      PRODUCT_COMBO_ORDER_TYPE,
      PRODUCT_TRIAL_TYPE,
      ORDER_VERSION,
      ORDER_RECEIPT_STATUS_MAP,
      statusTcNames: namesOrderContactStatusTc,
      orderDepositType: ORDER_DEPOSIT_TYPE,
      orderFinishType: ORDER_FINISH_TYPE,
      STATUS_COURSES,
      listClass: [{
        name: 'TOAN HOC 5',
        status: 'Lop dang hoc',
        endDate: 'Thứ 2, 20/12/2022',
        lastLogin: 'Thứ 2, 20/12/2022',
        subjectId: 1,
        status_color: '#60d254',
        status_name: 'Lớp đang học',
        level: 'cơ bản',
        color_level: '#24981f',
      }, {
        name: 'TA 5',
        status: 'Lop dang hoc',
        endDate: 'Thứ 2, 20/12/2022',
        lastLogin: 'Thứ 2, 20/12/2022',
        subjectId: 5,
        status_color: '#60d254',
        level: 'nâng cao',
        color_level: '#f39f55',
        status_name: 'Lớp đang học',
      }],
      listDuoCareStatusOfCall: [],
      duoNote: {
        callStatusId: null,
        note: null,
      },
      disableSubmit: false,
      itemsCareTabs: [
        // { key: 'routine-care', title: 'CHĂM SÓC ĐỊNH KỲ' },
        // { key: 'extend', title: 'GIA HẠN' },
        // { key: 'study-result', title: 'KẾT QUẢ HỌC TẬP' },
        // { key: 'order-list', title: 'ĐƠN HÀNG' },
        // { key: 'care-logs', title: 'LOG' },
      ],
      tabCare: 0,
      totalListOrder: [],
      listHistoryCare: [],
      listDuoCareLog: [],
      isShareComment: false,
      isEditComment: false,
      itemReview: false,
      statusColor: {
        1: 'status-orange',
        2: 'status-green',
        0: 'status-gray',
      },
      listReviewCare: [],
      orderList: [],
      listTransferOrder: [],
      listTransferOrderV2: [],
      loading: false,
      SUBJECTS_SORT_CLASS,
      LOAI_GIAOVIEN,
      PACKAGE_FEE,
    };
  },
  async created() {
    this.checkUserPermission();
    this.listHistoryCare = await this.getAllHistoryCare(this.studentDuoDetail);
    this.getListStatusOfCall(this.studentDuoDetail);
    this.getListClass(this.studentDuoDetail);
    this.tabCare = this.studentDuoDetail.type_customer_care === 1 ? 0 : 1;
  },
  methods: {
    ...mapActions('student_care', ['getContactOrder', 'getTransferOrderStudents', 'getTransferOrderStudentsV2', 'apiUpdate', 'getContactLogs']),
    crmOrderDetailLink(item) {
      return `${process.env.VUE_APP_CRM}/order-detail/${item.id}?orderList=true`;
    },
    handleRedirectOrder(item) {
      // const routeData = this.$router.resolve({ name: 'OrderDetail', params: { id: item.id }, query: { orderList: true } });
      window.open(`${process.env.VUE_APP_CRM}/order-detail/${item.id}?orderList=true`, '_blank');
    },
    openDetailOrder(order) {
      if (order.version === 1) {
        const routeData = `${process.env.VUE_APP_CRM}/order-detail/${order.id}?orderList=true`;
        window.open(routeData, '_blank');
      } else {
        const routeData = `${process.env.VUE_APP_CRM}/order-detail-new/${order.contactId}?order=${order.id}`;
        window.open(routeData, '_blank');
      }
    },
    openDetailOrderGroup(order) {
      const id = order.listOrders.find((item) => item.code === order.code);
      const routeData = `${process.env.VUE_APP_CRM}/order-detail/${id.id}?orderList=true`;
      window.open(routeData, '_blank');
    },
    toOrderDetail(id) {
      if (!id) {
        return;
      }
      const routeData = `${process.env.VUE_APP_CRM}/order-detail/${id}?codeOrder=2`;
      window.open(routeData, '_blank');
    },

    isShowPayMoreBtn(item) {
      return item.contactStatus && (item.contactStatus.code === 'T_DATT1P' || item.contactStatus.code === 'C_DATT1P');
    },
    isAllTheSameUser(listOrder) {
      if (!listOrder) return true;
      const userId = _.get(listOrder[0], 'userId', null);
      // eslint-disable-next-line no-plusplus
      for (let k = 1; k < listOrder.length; k++) {
        if (listOrder[k].userId !== userId) {
          return false;
        }
      }
      return true;
    },
    getDepositLabel(listOrder) {
      if (listOrder.every((item) => namesOrderContactStatusTc.includes(item.contactStatus.name.toUpperCase())) && listOrder.some((item) => item.orderType === ORDER_FINISH_TYPE)) {
        return 'Đã hoàn thành phí';
      } if (listOrder.some((item) => namesOrderContactStatusTc.includes(item.contactStatus.name.toUpperCase()))) {
        return 'Đã thanh toán 1 phần';
      }
      return 'Chưa thanh toán';
    },
    handleChangeLoadingState(val) {
      this.loading = val;
    },
    checkUserPermission() {
      if (this.checkPermission('student-extend-tab_read')) {
        this.itemsCareTabs.unshift(
          {
            key: 'extend',
            title: 'GIA HẠN',
          },
        );
      }
      if (this.checkPermission('student-periodic-care-tab_read')) {
        this.itemsCareTabs.unshift(
          {
            key: 'routine-care',
            title: 'CHĂM SÓC ĐỊNH KỲ',
          },
        );
      }
      if (this.checkPermission('student-detail_read')) {
        this.itemsCareTabs.push(
          { key: 'study-result', title: 'KẾT QUẢ HỌC TẬP' },
          { key: 'order-list', title: 'ĐƠN HÀNG' },
          { key: 'care-logs', title: 'LOG' },
          { key: 'ticket', title: 'Ticket' },
          { key: 'exchange', title: 'Trao đổi' },
        );
      }
    },
    async createDuoCareNote() {
      this.disableSubmit = true;
      const user = TokenService.getUser();
      const itemStudentCareSelected = this.getItemCareSelected();
      const body = {
        routine_student_id: itemStudentCareSelected.id,
        call_id: itemStudentCareSelected.call_id,
        call_name: this.mapCallStatus && this.mapCallStatus[itemStudentCareSelected.call_status_id] ? this.mapCallStatus[itemStudentCareSelected.call_status_id].callType : '',
        note: this.duoNote.note,
        subject_id: this.studentDuoDetail.subject_id,
        call_status_id: this.duoNote.callStatusId,
        call_status_name: this.mapCallStatus && this.mapCallStatus[this.duoNote.callStatusId] ? this.mapCallStatus[this.duoNote.callStatusId].callStatus : '',
        created_name: user.username,
        created_by: user.id,
        lms_core_user_id: this.studentDuoDetail.lms_core_user_id,
        curriculum_id: this.studentDuoDetail.curriculum_id,
        type_curriculum: this.studentDuoDetail.type_curriculum,
        type_customer_care: this.tabCare === 0 ? 1 : 2,
      };
      const oldData = {
        call_name: body.call_name,
        call_status_name: this.mapCallStatus[itemStudentCareSelected.call_status_id].callStatus,
      };
      const params = {
        obj: 'call-histories-detail',
        data: body,
        oldData,
      };
      const response = await this.apiUpdate(params);
      if (response && response.message === 'Success') {
        this.$swal({
          type: 'success',
          icon: 'success',
          title: 'Tạo thành công !',
          toast: true,
          showConfirmButton: false,
          timer: 1500,
        });
        if ((this.tabCare === 0 && this.studentDuoDetail.type_customer_care === 1) || (this.tabCare === 1 && this.studentDuoDetail.type_customer_care === 2)) {
          this.studentDuoDetail.call_status_id = this.duoNote.callStatusId;
          this.studentDuoDetail.call_status_name = body.call_status_name;
        } else {
          this.studentDuoRelated.call_status_id = this.duoNote.callStatusId;
          this.studentDuoDetail.call_status_name = body.call_status_name;
        }
        this.duoNote.note = null;
        this.duoNote.callStatusId = null;
        this.$nextTick(() => {
          this.$refs.validator.forEach((e) => {
            e.reset();
          });
        });
        this.$refs['duo-note'].forEach((e) => {
          e.blur();
        });
        this.listHistoryCare = await this.getAllHistoryCare({
          ...this.studentDuoDetail,
          type_customer_care: this.tabCare === 0 ? 1 : 2,
        });
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: `Có lỗi xảy ra khi tạo note: ${response.message}!!!`,
        });
      }
      this.disableSubmit = false;
    },
    openShareComment(item) {
      this.isShareComment = true;
      this.itemReview = item;
    },
    openEditComment(item) {
      this.isEditComment = true;
      this.itemReview = item;
    },
    async changeTabDuoCare(tab) {
      switch (tab.key) {
        case 'routine-care':
          this.listHistoryCare = await this.getAllHistoryCare({
            ...this.studentDuoDetail,
            type_customer_care: 1,
          });
          this.getListStatusOfCall({
            call_id: this.studentDuoDetail.type_customer_care === 1 ? this.studentDuoDetail.call_id : this.studentDuoRelated.call_id,
          });
          this.duoNote.callStatusId = null;
          break;
        case 'extend':
          this.listHistoryCare = await this.getAllHistoryCare({
            ...this.studentDuoDetail,
            type_customer_care: 2,
          });
          this.getListStatusOfCall({
            call_id: this.studentDuoDetail.type_customer_care === 2 ? this.studentDuoDetail.call_id : this.studentDuoRelated.call_id,
          });
          this.duoNote.callStatusId = null;
          break;
        case 'study-result':
          break;
        case 'order-list':
          if (!this.totalListOrder.length) {
            this.fetchContactOrders();
          }
          break;
        case 'care-logs':
          this.getLogDuoCare();
          break;
        case 'exchange':
          if (this.$refs.exchangeTab) {
            this.$refs.exchangeTab[0].getListExchange();
          }
          break;
        default: break;
      }
    },
    async fetchContactOrders() {
      this.loading = true;
      const result = await this.getContactOrder(this.contactData?.id);
      if (result && result.data && result.data.length > 0) {
        this.orderList = result.data;
        this.totalItem = result.totalItem;
      }
      const res = await this.getTransferOrderStudents(this.contactData?.id);
      if (res && res.length > 0) {
        this.listTransferOrder = res;
      }
      const resTransferOrderV2 = await this.getTransferOrderStudentsV2(this.contactData?.id);
      if (resTransferOrderV2 && resTransferOrderV2.length > 0) {
        this.listTransferOrderV2 = resTransferOrderV2.map((el) => ({
          ...el,
          isTransferOrder: true,
          version: 2,
        }));
      }
      const totalListOrder = await Promise.all(this.orderList.concat(this.listTransferOrder).concat(this.listTransferOrderV2).map(async (s) => {
        let depositLabel = null;
        let hasFinishOrder = null;
        let isAllTheSameUserCreate = null;
        if (s.isGroupOrder) {
          const depositOrder = s.listOrders.find((item) => item.orderType === ORDER_DEPOSIT_TYPE);
          if (depositOrder) {
            // eslint-disable-next-line no-param-reassign
            s.code = depositOrder.code;
            // eslint-disable-next-line no-param-reassign
            s.depositOrderId = depositOrder.id;
          }

          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < s.listOrders.length; i++) {
            // call api trail
            // eslint-disable-next-line no-await-in-loop
            const trailData = await OrderRepository.getTrailOfOrder(s.listOrders[i].id);

            let trailProduct = [];
            if (trailData.success) {
              trailProduct = _.get(trailData, 'data.trailProductData', []);
            }
            // eslint-disable-next-line no-param-reassign
            s.listOrders[i].isTrail = !!trailProduct.length;
            // console.log('s.listOrders[i].id trailProduct: ', s.listOrders[i].id, trailProduct.length)

            // eslint-disable-next-line no-param-reassign
            s.listOrders[i].products = s.listOrders[i].products.map((prod) => {
              const trailProductFind = trailProduct.find((trailP) => trailP.productId === prod.productId && trailP.customerId === prod.customerId);
              // eslint-disable-next-line no-nested-ternary
              const numberLessons = trailProductFind ? s.listOrders[i].orderType === ORDER_DEPOSIT_TYPE ? trailProductFind.trailLessons : +(trailProductFind.numberOfSection - trailProductFind.trailLessons) : null;
              return {
                ...prod,
                numberLessons,
              };
            });

            // eslint-disable-next-line no-param-reassign
            s.listOrders[i].combos = s.listOrders[i].combos.map((prod) => {
              const numberLessons = 0;
              return {
                ...prod,
                numberLessons,
              };
            });
          }
          depositLabel = this.getDepositLabel(s.listOrders);
          hasFinishOrder = s.listOrders.findIndex((e) => e.orderType === ORDER_FINISH_TYPE) > -1;
          isAllTheSameUserCreate = this.isAllTheSameUser(s.listOrders);
        }
        if (s && s.isTransferOrder) {
          return {
            ...s,
            statusOrder: true,
            hasFinishOrder,
            depositLabel,
            createdAt: moment(s.createdAt).format('YYYY-MM-DD HH:mm:ss'),
          };
        }
        if (s.created_date) {
          return {
            ...s,
            createdAt: moment(s.created_date).format('YYYY-MM-DD HH:mm:ss'),
            statusOrder: true,
            version: 1,
            hasFinishOrder,
            depositLabel,
          };
        }
        return {
          ...s,
          statusOrder: false,
          hasFinishOrder,
          depositLabel,
          isAllTheSameUserCreate,
        };
      }));
      this.totalListOrder = _.orderBy(totalListOrder, ['createdAt'], ['ASC']).reverse();
      this.loading = false;
    },
    changeSubject(item) {
      this.filterForm.subjectId = item.subjectId;
      Bus.$emit('change-data-top-content-right-subject');
    },
    async getListStatusOfCall(params) {
      if (!params.call_id) return;
      const res = await StudentCareServices.fgGetListCare({
        obj: 'call-status',
        attrs: ['id', 'typeId', 'name', 'code', 'color', 'numberOrder'],
        'filters[$eq__typeId]': params.call_id,
        'sorts[numberOrder]': 'asc',
      });
      if (res?.success) {
        this.listDuoCareStatusOfCall = res?.data;
      }
    },
    async getListClass(params) {
      const res = await StudentCareServices.fgGetListCare({
        obj: 'tutor-routine-student',
        attrs: [
          'id', 'name', 'number_lessons_passed', 'status_name', 'class_start_time', 'class_schedule',
          'number_lessons', 'status_color', 'class_level', 'contact_id', 'student_product_id', 'class_id',
          'teacher_type', 'student_id', 'teacher_full_name', 'learn_again_time', 'curriculum_id', 'join_date',
        ],
        'filters[$eq__lms_core_user_id]': params.lms_core_user_id,
        'filters[$eq__subject_id]': this.filterForm.subjectId,
      });
      if (res?.success) {
        this.listClass = res?.data;
      } else {
        console.log('Lỗi: ', res?.message);
      }
    },
    getItemCareSelected() {
      if (this.tabCare === 0) { // CSDK
        return this.studentDuoDetail.type_customer_care === 1 ? this.studentDuoDetail : this.studentDuoRelated;
      }
      // Gia hạn
      return this.studentDuoDetail.type_customer_care === 2 ? this.studentDuoDetail : this.studentDuoRelated;
    },
    async getLogDuoCare() {
      this.listDuoCareLog = [];
      this.loading = true;
      const [careHistoriesDetail, logContact] = await Promise.all([
        this.getAllHistoryCare({
          ...this.studentDuoDetail,
          type_customer_care: undefined,
        }),
        this.getContactLogs(this.studentDuoDetail.contact_id),
      ]);
      this.loading = false;
      const careHistoriesDetailForLog = careHistoriesDetail.filter((e) => e.created_by === 100004 || e.type_customer_care === null);
      const logs = [...careHistoriesDetailForLog, ...logContact].map((e) => ({
        creatorFullName: e?.creator?.fullName || e?.created_name || contactCreator[e?.createdBy],
        description: e?.note || e?.description,
        createdAt: e.created_at || e.createdAt,
      }));
      this.listDuoCareLog = _.orderBy(logs, ['createdAt'], ['desc']);
    },
    async getAllHistoryCare(params) {
      const res = await StudentCareServices.fgGetListCare({
        obj: 'call-histories-detail',
        attrs: ['id', 'created_name', 'note', 'call_name', 'call_status_name', 'call_status_id', 'call_id', 'created_at', 'created_by', 'type_customer_care'],
        'filters[$eq__lms_core_user_id]': params.lms_core_user_id,
        'filters[$eq__type_customer_care]': params.type_customer_care,
        'sorts[created_at]': 'desc',
      });
      if (res?.success) {
        return res?.data;
      }
      return [];
    },
    subjectTransfer(id) {
      let subject;
      /* eslint-disable */
      SUBJECTS_SORT_CLASS.map((s) => {
        if(s.id === parseInt(id)) {
          return subject = s.name
        }
      })
      /* eslint-enable */
      return subject;
    },
    typeTeacher(id) {
      let typeTeacher;
      /* eslint-disable */
      LOAI_GIAOVIEN.map((s) => {
        if(s.id === id) {
            return typeTeacher = s.name
        }
      })
      /* eslint-enable */
      return typeTeacher;
    },
    showTotalSubject() {
      const total = this.listSubjects.reduce((acc, e) => acc + e.courses.length, 0);
      return total;
    },
  },
  computed: {
    ...mapGetters('user', ['isTutorHomeroomTeacher']),
    ...mapGetters('contact_status', ['mapCallStatus']),
    ...mapState('duo_care', ['activeClass']),
    listSubjectDetailFilter() {
      const listSubjectDetail = this.listSubjects.find((e) => e.subjectId === this.filterForm.subjectId);
      return listSubjectDetail.courses;
    },
    subjectName() {
      if (!this.filterForm?.subjectId) return '';
      return this.listSubjects.find((e) => e.id === this.filterForm?.subjectId)?.name || '';
    },
    listClassFilter() {
      if (!this.filterForm?.subjectId) return this.listClass;
      return this.listClass.filter((e) => e.subjectId === +this.filterForm?.subjectId);
    },
  },
  watch: {
  },
  beforeDestroy() {
  },
};
</script>
<style scoped>
.col.col-4, .col.col-8 {
  background: white;
}
.col.col-3, .col.col-9 {
  border-radius: 8px;
  background: white;
}
</style>
<style lang="scss">
.duo-care-form {
  display: flex;
  align-items: center;
}
.bottom-content {
  flex-wrap: nowrap;
  width: 100%;
  margin-top: 0px !important;
}
.bottom-left-title {
  display: flex;
}
.bottom-left-title .bottom-left-title-item {
  border-radius: 5px;
  padding: 5px 15px;
  margin-right: 10px;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;
  background: #eff0f6;
}
.bottom-left-title .bottom-left-title-item.active {
  background: #0EA5BA !important;
  color: white;
}
.update-button {
  background-color: #fd1f6d !important;
  color: white !important;
}
.col.col-8 {
  max-width: 65% !important;
}
.class-studying-item {
  border: 1px solid #b1a3a3;
  border-radius: 5px;
  padding: 15px;
}
.list-status-history-timeline, .list-status-current {
  border-radius: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  text-align: center;
}
.list-status-history-timeline {
  width: 120px;
  min-height: 38px;
  padding-top: 2px;
  line-height: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-history-care .list-status-history-timeline {
  width: fit-content !important;
  margin: 0 auto;
}
.history-care-content {
  max-height: 400px;
  overflow-y: auto;
}
.v-progress-circular {
  margin: 1rem;
}
.border-item {
  border: #9c9c9c 1px solid;
  border-radius: 5px;
}
thead tr th {
  /*text-align: center !important;*/
  font-size: 14px !important;
}
.history-care-item-bottom > div {
  padding: 10px;
  margin: 0 20px;
}
.history-care-item-bottom {
  background-color: #f6f6f6;
  margin: 0px !important;
  padding: 5px;
  border-radius: 8px;
}
.custom-timeline .v-timeline-item .v-timeline-item__divider .v-timeline-item__dot{
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  .v-timeline-item__inner-dot {
    background-color: transparent !important;
    width: 120px;
  }
}
.custom-timeline .v-timeline-item__body{
  margin-top: -30px
}
.v-application--is-ltr .v-timeline--dense:not(.v-timeline--reverse):before {
  left: calc(60px - 1px) !important;
}
.history-care-created-at {
  color: #828282;
}

</style>
<style lang="scss" scoped>
.transfers-order {
    background: #F1F7FF;
    margin: 16px 16px 26px 16px;
    border-radius: 6px;
    padding: 12px;
    .transfers-order-name {
    color: black;
    font-weight: 700;
    text-align: left;
    span {
        color: #828282;
        }
    }
    .transfers-order-info {
        display: flex;
        width: 100%;
        text-align: left;
        .transfers-order-item {
            color: #6A2C62;
            font-weight: 700;
            width: 50%;
            span {
                color: #333333;
            }
        }
        .transfers-order-icon {
            width: 23px;
            height: 23px;
            text-align: center;
            background: #6A2C62;
        }
    }
}
.border-order {
  border-bottom: #9c9c9c 1px solid;
  border-radius: 5px;
}
.log-deposit {
  display: flex;
}
.log-deposit-status {
  width: 85px;
}
.log-deposit-info {
  display: flex;
  width: calc(100% - 85px);
  justify-content: space-between;
  margin-right: 28px;
}
.deposit {
  background: #268A42 ;
  color: white;
  border-radius: 3px;
  font-weight: bold;
  width: 70px;
  display: flex;
  justify-content: center;
  padding: 6px;
}
.deposit.finished {
  background: #6A2C62;
}
.receipt-status-box {
  display: flex;
  justify-content: center;
  min-width: 105px;
  color: white;
  width: fit-content;
  padding: 0px 12px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 2;
  white-space: nowrap;
}
.receipt-status-box.success {
  background: #279600;
}
.receipt-status-box.primary {
  background-color: #184BFF !important;
}
.order-detail-box {
  padding: 12px 12px;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  height: 100%;
}
</style>
